import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * ScrollToTop — mounts once inside <BrowserRouter> and jumps the window to
 * the top on every route change so navigating to a new page never dumps the
 * user midway down (a classic SPA gotcha React Router v6 does not fix by
 * default).
 *
 * Behavior:
 *   - PUSH / REPLACE navigations (link clicks, programmatic navigate): scroll
 *     to top instantly. Smooth scroll gets swallowed by React 18 concurrent
 *     rendering and feels laggy, so we use `auto`.
 *   - POP navigations (back / forward): leave the browser's scroll restoration
 *     alone so users return to where they were.
 *   - If the URL has a `#hash`, honor it — let the anchor take precedence.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (hash) return;                 // anchor link wins
    if (navType === "POP") return;    // preserve back/forward scroll
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash, navType]);

  return null;
}
